import { render, staticRenderFns } from "./MultiSelectTag.vue?vue&type=template&id=042b4152&scoped=true&"
import script from "./MultiSelectTag.vue?vue&type=script&lang=js&"
export * from "./MultiSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042b4152",
  null
  
)

export default component.exports